let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bJVPM")).then(() => parcelRequire('6ZEj6'));